var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"font-weight-bold overline",attrs:{"small":"","color":_vm.templateType.color,"text-color":"white"}},[_vm._v(_vm._s(_vm.templateType.name))])}
var staticRenderFns = []

export { render, staticRenderFns }